import { render, staticRenderFns } from "./LoginOverlay.vue?vue&type=template&id=4a3a6570&scoped=true&"
import script from "./LoginOverlay.vue?vue&type=script&lang=js&"
export * from "./LoginOverlay.vue?vue&type=script&lang=js&"
import style0 from "./LoginOverlay.vue?vue&type=style&index=0&id=4a3a6570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3a6570",
  null
  
)

export default component.exports